import Link from 'next/link';
import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  width: 100%;
  max-width: 600px;
  background-color: ${(props) => props.theme.background};
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 12;
`;

export const RelativeBox = styled.div`
  position: relative;
`;

export const Content = styled(Link)`
  display: flex;
  padding: 10px 30px 10px 10px;
`;

export const PropertyImage = styled.img`
  max-height: 100px;
  margin-right: 10px;
`;

export const CloseIcon = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
`;

export const SliderBar = styled.div`
  background-color: ${(props) => props.theme.primary};
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
